<template>
    <v-list-item :to="{ name: 'M_Wire sequence' }" :disabled="disabled">
        <v-list-item-icon>
            <v-icon>mdi-cable-data</v-icon>
        </v-list-item-icon>
        
        <v-list-item-content>
            <v-list-item-title>Wire sequence</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'mNavItemWireSequence',
    props: {
        disabled: Boolean,
    }
}
</script>